
<div>
  <mat-tab-group>
    <mat-tab label="Call To Action">
      <mat-form-field class="pe-se-input">
        <mat-label>Header</mat-label>
        <input matInput
               [(ngModel)]="item.data.header">
      </mat-form-field>
      <mat-form-field class="pe-se-input">
        <mat-label>Description</mat-label>
        <textarea matInput
                  [(ngModel)]="item.data.description">
        </textarea>
      </mat-form-field>
      <div *ngFor="let l of item.data.Buttonlink;index as index;last as isLastIndex;" class="link-containers">
        <span class="fa fa-times" (click)="RemoveLink(index)" title="Remove this link"></span>
        <br />
        <mat-form-field class="pe-se-input">
          <mat-label>Button Text {{index +1}}</mat-label>
          <input matInput
                 [(ngModel)]="l.text">
        </mat-form-field>

        <mat-form-field class="pe-se-input">
          <mat-label>Button Link {{index +1}} </mat-label>
          <input matInput
                 [(ngModel)]="l.link" type="url">
        </mat-form-field>

        <div class="appearence-button-row">
          <button mat-raised-button (click)="SelectButtonStyle(null, index)" title="Button Appeareance: Basic">&nbsp;</button>
          <button mat-raised-button color="primary" (click)="SelectButtonStyle('primary', index)" title="Button Appeareance: Primary">&nbsp;</button>
          <button mat-raised-button color="accent" (click)="SelectButtonStyle('accent',index)" title="Button Appeareance: Accent">&nbsp;</button>
          <button mat-raised-button color="warn" (click)="SelectButtonStyle('warn',index)" title="Button Appeareance: Warn">&nbsp;</button>
        </div>
        <br/>
      </div>

      <div class="text-center">
        <button class="addLink" mat-raised-button color="primary" (click)="AddLink()">Add Link</button>
      </div>
    </mat-tab>


    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>


</div>
